import api from "./api";

class ReportService {
  walletReport(dataForm) {
    return api.post(
      "/admin/merchant/report/wallet",
      dataForm
    );
  }
}

export default new ReportService();
